<div class="my-4 mx-5">
    <div class="wrapper mb-2">
        <div class="row align-items-center m-0 mb-5" style="padding: 10px;">
            <img class="p-2" src="./assets/icons/arrow.svg">
            <span class="label-title ml-2 mr-3">Vincular Cartão: {{collaboratorName}}</span>
        </div>
        <div class="my-0 alert alert-light" role="alert">
            <div class="row p-3">
                <div class="p-0 mx-3 align-self-center">
                    <img src="../../../../../../assets/icons/logo_icon.svg" alt="" height="50px" class="">
                </div>
                <div class="col-11 p-0 m-0 align-self-center">
                    <p class="m-0">
                        <strong>Quando utilizar esse procedimento:</strong>
                        <br>Em casos em que o favorecido não possua acesso a um smartphone para ativar o cartão por meio do aplicativo Bankei Beneflex, disponível gratuitamente nas lojas do Google Play e Apple Store.
                    </p>
                </div>
            </div>
        </div>
        <div class="container-fluid">
            <div class="row">
                <div class="col-6 pl-0">
                    <div class="component-box container-fluid" style="min-height: 50%;">
                        <app-colaborador-vincular-cartao-form></app-colaborador-vincular-cartao-form>
                    </div>
                </div>
                <div class="col-6 pl-2 pr-0">
                    <div class="component-box container-fluid">
                        <app-colaborador-vincular-cartao-info></app-colaborador-vincular-cartao-info>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

